import { biography, idealAudiences, languages, positioning, siteLinks } from '../../content/siteContent';
import { AnimatedSection } from '../components/AnimatedSection';
import { BookingCta } from '../components/BookingCta';

const credentials = [
  'Senior and NQA Level IV Advanced Qigong Instructor',
  'Master’s-level Medical Qigong Therapist',
  'Certified Personal Trainer and Nutritionist',
  'Health and Wellness Coach',
  'Award-winning author of Qigong Illustrated',
  'Producer and host of three Qigong television seasons'
] as const;

export function AboutPage() {
  return (
    <>
      <header className="page-hero page-hero--split">
        <div><p className="eyebrow">About</p><h1>About Christina</h1><p className="page-hero__lead">{positioning.promise}—made practical, personal, and alive.</p></div>
        <img src="/images/christina-hero.png" alt="Christina J Barea in her Five Phases Health uniform" />
      </header>

      <AnimatedSection className="story-section">
        <p className="eyebrow">A life in practice</p>
        <div className="story-section__copy">{biography.map((paragraph) => <p key={paragraph}>{paragraph}</p>)}</div>
      </AnimatedSection>

      <AnimatedSection className="credentials-section">
        <div><p className="eyebrow">Experience</p><h2>Depth earned across disciplines.</h2></div>
        <ul>{credentials.map((credential) => <li key={credential}>{credential}</li>)}</ul>
      </AnimatedSection>

      <AnimatedSection className="language-band">
        <p>Speaking in</p>
        <h2>{languages.join(' · ')}</h2>
      </AnimatedSection>

      <AnimatedSection className="audience-section">
        <p className="eyebrow">Built for many rooms</p>
        <h2>From intimate retreats to international conferences.</h2>
        <ul>{idealAudiences.map((audience) => <li key={audience}>{audience}</li>)}</ul>
        <a className="brand-link" href={siteLinks.fivePhases}>
          <img src="/images/five-phases-health-logo.png" alt="5 Phases Health" />
          <span>Explore Christina’s broader health and education work</span>
        </a>
      </AnimatedSection>

      <BookingCta />
    </>
  );
}
